import { Children, cloneElement, isValidElement } from "react"

const VARIANT_STYLES = {
  default: "bg-gradient-to-r from-rose-900 to-red-800 text-white hover:from-rose-800 hover:to-red-700 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  primary: "bg-gradient-to-r from-sky-700 to-blue-800 text-white hover:from-sky-600 hover:to-blue-700 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  secondary: "bg-gradient-to-r from-purple-800 to-violet-900 text-white hover:from-purple-700 hover:to-violet-800 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  success: "bg-gradient-to-r from-green-700 to-emerald-800 text-white hover:from-green-600 hover:to-emerald-700 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  danger: "bg-gradient-to-r from-red-700 to-rose-800 text-white hover:from-red-600 hover:to-rose-700 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  warning: "bg-gradient-to-r from-orange-700 to-amber-800 text-white hover:from-orange-600 hover:to-amber-700 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  outline: "border-2 border-rose-900 text-rose-900 hover:bg-rose-50 dark:hover:bg-rose-950/20 transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
  ghost: "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-200",
  destructive: "bg-gradient-to-r from-red-800 to-rose-900 text-white hover:from-red-700 hover:to-rose-800 shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
}

const SIZE_STYLES = {
  default: "px-4 py-2 text-sm font-semibold rounded-lg",
  sm: "text-xs py-1.5 px-3 font-semibold rounded-md",
  lg: "text-base py-3 px-6 font-semibold rounded-xl",
  icon: "h-10 w-10 p-0 aspect-square rounded-lg",
}

export function Button({
  asChild = false,
  variant = "default",
  size = "default",
  className = "",
  disabled = false,
  children,
  ...props
}) {
  const classes = [
    "inline-flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none",
    VARIANT_STYLES[variant] ?? VARIANT_STYLES.default,
    SIZE_STYLES[size] ?? SIZE_STYLES.default,
    className,
  ]
    .filter(Boolean)
    .join(" ")

  if (asChild && isValidElement(children)) {
    const child = Children.only(children)
    return cloneElement(child, {
      className: [classes, child.props.className].filter(Boolean).join(" "),
      disabled,
      ...props,
    })
  }

  return (
    <button className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  )
}

export default Button




